import { cn } from "@/lib/utils";
import { USAGE_ANALYTICS_UNAVAILABLE } from "@/lib/usage-messages";

export function UsageUnavailable({ className }: { className?: string }) {
  return <p role="alert" className={cn("text-sm text-muted-foreground", className)}>{USAGE_ANALYTICS_UNAVAILABLE}</p>;
}
